import { BMPrimitives } from "@traveloka/district-bloom";
import { Animated, StyleSheet } from "react-native";
import {
  ACTIVE_DOT_SIZE,
  DOT_GAP,
  INACTIVE_DOT_COLOR,
  INACTIVE_DOT_SIZE,
} from "./constants";

type Props = {
  value: Animated.Value;
  spacing?: boolean;
  testID?: string;
};

export default function SpotlightDot({ value, spacing, testID }: Props) {
  const size = value.interpolate({
    inputRange: [0, 1],
    outputRange: [INACTIVE_DOT_SIZE, ACTIVE_DOT_SIZE],
  });
  const borderRadius = value.interpolate({
    inputRange: [0, 1],
    outputRange: [INACTIVE_DOT_SIZE / 2, ACTIVE_DOT_SIZE / 2],
  });
  const backgroundColor = value.interpolate({
    inputRange: [0, 1],
    outputRange: [INACTIVE_DOT_COLOR, BMPrimitives.BMBrand.primary],
  });

  return (
    <Animated.View
      style={[
        { width: size, height: size, borderRadius, backgroundColor },
        spacing && styles.spacing,
      ]}
      testID={testID}
    />
  );
}

const styles = StyleSheet.create({
  spacing: { marginLeft: DOT_GAP },
});
